export enum StatusIdEnum {
    Indefinido = -2,
    Sigma = -1,
    Cotacao = 0,
    Pedido = 1,
    EmAnalise = 2,
    Confirmado = 3,
    AguardandoConfirmacaoTroca = 5,
    AguardandoTroca = 6,
    AguardandoConfirmacaoDevolucao = 7,
    AguardandoDevolucao = 8,
    Entregue = 15,
    CotacaoCanceladaComprador = 20,
    CotacaoCanceladaSuporte = 21,
    PecaRejeitadaoComprador = 22,
    PecaRejeitadaoVendedor = 23,
    PecaDevolvidaComprador = 24,
}

export function isAwaitingConfirmationAfterDelivered(statusId: number): boolean {
    let status = [StatusIdEnum.AguardandoConfirmacaoTroca, StatusIdEnum.AguardandoConfirmacaoDevolucao]
    return status.includes(statusId);
}

export function isAwaitingConfirmation(statusId: number): boolean {
    let status = [StatusIdEnum.Pedido, StatusIdEnum.EmAnalise, StatusIdEnum.AguardandoConfirmacaoTroca, StatusIdEnum.AguardandoConfirmacaoDevolucao]
    return status.includes(statusId);
}

export function isOldStatusConfirmado(statusId: number): boolean {
    let status = [StatusIdEnum.Confirmado, StatusIdEnum.AguardandoConfirmacaoTroca, StatusIdEnum.AguardandoTroca, StatusIdEnum.AguardandoConfirmacaoDevolucao, StatusIdEnum.AguardandoDevolucao]
    return status.includes(statusId);
}

export function isFinalStatus(statusId: number): boolean {
    let status = [
        StatusIdEnum.Entregue,
        StatusIdEnum.CotacaoCanceladaComprador,
        StatusIdEnum.CotacaoCanceladaSuporte,
        StatusIdEnum.PecaRejeitadaoComprador,
        StatusIdEnum.PecaRejeitadaoVendedor,
        StatusIdEnum.PecaDevolvidaComprador
    ]
    return status.includes(statusId);
}
